module.exports = __webpack_public_path__ + "static/media/NunitoSans-Regular.4c8f4470.ttf";